import type { CMSMenuItem } from '@/src/domains/cms-menus/schemas'
import { getCMSMenuItemHref } from '@/src/domains/cms-menus/utils/getCMSMenuItemHref'
import {
  HeaderMainNavigationContent,
  HeaderSubNavigationType,
} from '@/src/domains/header/components/Header/Header.constants'
import { StrapiMenuSpecialFunction } from '@/src/domains/strapi/constants'

export type HeaderMenuNavigationItem = { id: string | number; title: string } & (
  | { href: string; content?: never }
  | { href?: never; content: HeaderMainNavigationContent }
)

const contentBySpecialFunction: Partial<Record<StrapiMenuSpecialFunction, HeaderMainNavigationContent>> = {
  [StrapiMenuSpecialFunction.OTHER]: HeaderMainNavigationContent.OTHER,
  [StrapiMenuSpecialFunction.THERAPISTS]: HeaderMainNavigationContent.THERAPISTS,
  [StrapiMenuSpecialFunction.CLINIC]: HeaderMainNavigationContent.CLINIC,
  [StrapiMenuSpecialFunction.BUSINESS_HOW]: HeaderMainNavigationContent.BUSINESS_HOW,
  [StrapiMenuSpecialFunction.BUSINESS_SOLUTION]: HeaderMainNavigationContent.BUSINESS_SOLUTION,
}

const subNavigationTypeBySpecialFunction: Partial<Record<StrapiMenuSpecialFunction, HeaderSubNavigationType>> = {
  [StrapiMenuSpecialFunction.SPECIALIZATIONS]: HeaderSubNavigationType.TAGS,
  [StrapiMenuSpecialFunction.CLINIC_LOCATION]: HeaderSubNavigationType.TAGS,
}

const mapAction = (item: CMSMenuItem) => {
  const content = contentBySpecialFunction[item.special_function ?? StrapiMenuSpecialFunction.NONE]

  return content ? { content } : { href: getCMSMenuItemHref(item) }
}

export const getHeaderMainNavigationItems = (menu: CMSMenuItem[]): HeaderMenuNavigationItem[] =>
  menu.map((item) => ({
    id: item.id,
    title: item.title,
    ...mapAction(item),
  })) as HeaderMenuNavigationItem[]

export const getHeaderSubmenu = (menu: CMSMenuItem) => ({
  id: menu.id.toString(),
  title: menu.title,
  items: (menu.children ?? []).map((item) => ({
    href: getCMSMenuItemHref(item),
    title: item.title,
    target: item.target ?? undefined,
  })),
  special_function: menu.special_function,
  type:
    subNavigationTypeBySpecialFunction[menu.special_function ?? StrapiMenuSpecialFunction.NONE] ??
    HeaderSubNavigationType.DEFAULT,
})
